//@flow
import * as actionTypes from './actionTypes';
import {
    submitTaskApi,getTaskApi,getVendorsApi
} from '../../apiUtils/api';
import type { Dispatch,ReducerState$Type,PostPayloadData } from './flowTypes'
import { transformDataToEditFormData } from './editFormData'
import { getReviewOutcome } from '../demeter/submitFormData'

export const getTaskData=(eros:ReducerState$Type, jwt:string,taskAcceptedInfoId: number)=>{
    return (dispatch:Dispatch) => getTaskApi(jwt,'Eros',taskAcceptedInfoId.toString())
    .then((res)=>res.json()).then((data)=>{
        const error = (data.error:any|null)
        if (error){
            dispatch({type: actionTypes.EROS_EDIT_VERIFY_FORM_DATA_ERROR,error: error});
        }else {
            const formData = transformDataToEditFormData(data,eros)
            dispatch({
                type: actionTypes.EROS_EDIT_VERIFY_FORM_DATA_SUCCESS, 
                formData: formData,reviewQuestions: data['reviewQuestions'] });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.EROS_EDIT_VERIFY_FORM_DATA_ERROR, error: err});
    })
}

export const invoiceSubmissionCompleted = () => {
    return { type: actionTypes.EROS_INV_SUBMITTED_COMPLETED };
}

export const invoiceSubmission = (jwt:any,taskAcceptedInfoId:number,erosResultset:any,eros:ReducerState$Type)=>{
    let payload:PostPayloadData={
        taskAcceptedInfoId:taskAcceptedInfoId
    };

    if (erosResultset.isInvalidDoc){
        payload.isInvalidDoc=true;
    }else {
        payload.vendorName=erosResultset.vendorName;
        payload.invNo=erosResultset.invNo;
        payload.invDate=erosResultset.invDate;
        payload.dueDate=erosResultset.dueDate;
        payload.total=erosResultset.total;
        payload.isDocAStatement=erosResultset.isDocAStatement?erosResultset.isDocAStatement:false;
        payload.isInvalidDoc=erosResultset.isInvalidDoc?erosResultset.isInvalidDoc:false;
        payload.poNo=erosResultset.poNo?erosResultset.poNo:'';
        payload.jobNo=erosResultset.jobNo?erosResultset.jobNo:'';
        payload.isOverrideVendorName=erosResultset.isOverrideVendorName?erosResultset.isOverrideVendorName:false;
    }

    if (eros.reviewQuestions && eros.reviewQuestions.length > 0){
        payload.reviewOutcome=getReviewOutcome(erosResultset,eros.reviewQuestions)
    }
    
    return (dispatch:Dispatch) => submitTaskApi(jwt,payload).then((res)=>res.json()).then((data) =>{
        if (data['error']){
            dispatch({type: actionTypes.EROS_INV_SUBMIT_ERROR, error: data.error});
        }else {
            dispatch({type: actionTypes.EROS_INV_SUBMIT_SUCCESS});
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.EROS_INV_SUBMIT_ERROR, error: err});
    })
}

export const updateFormError=(error:any|null)=>{
    return { type: actionTypes.EROS_UPDATE_FORM_ERROR, formError: error }
}

export const populateVendorsList=(jwt:any)=>{
    return (dispatch:Dispatch) => getVendorsApi(jwt,'Eros').then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.REFRESH_EROS_VENDORS_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.REFRESH_EROS_VENDORS_SUCCESS, vendors: data.vendors });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.REFRESH_EROS_VENDORS_ERROR, error: err});
    })
}


// WEBPACK FOOTER //
// ./src/redux/eros/actions.js